import typography from 'fuse-ui/theme/typography';
import { action, background, opacity, error, text } from './colors';

/*  These styles are only for components that are not available in Fuse-ui
    They will override the fuse-ui styles so use responsibly
*/

const defaultPaddingVertical = 16;
const defaultPaddingHorizontal = 24;

export default{
    mixins: {
        toolbar: {
            '@media (min-width: 600px)': {
                minHeight: 56,
            },
            minHeight: 56,
        }
    },
    overrides: {
        MuiBackdrop: {
            root: {
                transform: 'translateZ(0)'
            }
        },
        MuiCard: {
            root: {
                border: `1px solid ${opacity.black14}`,
                boxShadow: 'none',
            }
        },
        MuiCardContent: {
            root: {
                '&:last-child': {
                    paddingBottom: defaultPaddingVertical,
                },
                paddingBottom: defaultPaddingVertical,
                paddingLeft: defaultPaddingHorizontal,
                paddingRight: defaultPaddingHorizontal,
                paddingTop: defaultPaddingVertical,
            },
        },
        MuiCardHeader: {
            root: {
                marginTop: 0,
                paddingBottom: 0,
                paddingLeft: defaultPaddingHorizontal,
                paddingRight: defaultPaddingHorizontal,
                paddingTop: defaultPaddingVertical,
            }
        },
        MuiExpansionPanel: {
            expanded: {
                margin: 'auto',
            },
            root: {
                '&:before': {
                    display: 'none',
                },
                '&:not(:last-child)': {
                    borderBottom: 0,
                },
                background: background.paper,
                boxShadow: 'none',
                padding: 0,
            },
        },
        MuiExpansionPanelDetails: {
            root: {
                padding: 0,
            }
        },
        MuiExpansionPanelSummary: {
            content: {
                '&$expanded': {
                    margin: '12px 0',
                },
            },
            expanded: {},
            root: {
                '&$expanded': {
                    minHeight: 36,
                },
                '&:focus': {
                    background: action.selected,
                },
                '&:hover': {
                    background: action.hover
                },
                background: background.paper,
                minHeight: 36,
            },
        },
        MuiIconButton: {
            root: {
                '&:hover': {
                    backgroundColor: opacity.black08,
                },
                fontSize: 24,
                height: 40,
                padding: 0,
                width: 40,
            }
        },
        MuiMenuItem: {
            root: Object.assign( {}, typography.body, {
                height: '12px',
            } )
        },
        MuiTabs: {
            root: {
                paddingTop: defaultPaddingVertical
            },
        },
    },
    palette: {
        error,
        text,
    },
};
